import { StatisticCart } from '@/entities/cart-page/StatisticCart/ui/StatisticCart'
import './ui/StatisticCart.scss'
export default StatisticCart
